import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("Help us design"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("a new accessible font")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "APH is designing a new font that will be easier for people with low vision to read. You can help us design the new font by taking this short survey. To keep the testing environment as uniform as possible, please take the survey in a well-lighted space.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "This survey will take approximately five minutes to complete.", -1)
const _hoisted_5 = { class: "flex justify-between mt-12" }


import Logo from './Logo.vue';
import Divider from './Divider.vue';
import PrimaryButton from './PrimaryButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FirstStep',
  emits: ["nextPage"],
  setup(__props, { emit }) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createVNode(Logo),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(Divider)
        ])
      ]),
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(PrimaryButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('nextPage')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Let's Begin ")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})